module.exports = __webpack_public_path__ + "img/Icon-SEL.c637349f.svg";